module.exports = __webpack_public_path__ + "assets/img/bannerBg.2ce45bf2.png";